import { createSlice } from "@reduxjs/toolkit";

const predictionSlice = createSlice({
  name: "prediction",
  initialState: {
    // y data stats
    multiFeatures: false,
    detranding: false,
    loadingFeatures: false,
    featuresColumn: [],
    selectedColumn: "",
    modelName: "",

    // indices
    addedIndexes: [],

    // reference
    refToggle: false,
    uploadMaskToggle: false,
    RefIndex: [],
    rangePairs: [],
    values: [],
    refFromDate: {},
    refToDate: {},
    chooseOneRef: false,
    refPredFromDate: {},
    refPredToDate: {},
  },
  reducers: {
    // y data
    setModelName: (state, action) => {
      state.modelName = action.payload;
    },
    setMultiFeature: (state) => {
      state.multiFeatures = !state.multiFeatures;
    },
    setDetranding: (state) => {
      state.detranding = !state.detranding;
    },
    setLoadingfeatures: (state, action) => {
      state.loadingFeatures = action.payload;
    },
    setFeaturesColumn: (state, action) => {
      state.featuresColumn = action.payload;
    },
    setSelectedFeaturesColumn: (state, action) => {
      state.selectedColumn = action.payload;
    },

    // indices
    setAddedIndexesInit: (state, _) => {
      const mainIndex = state.addedIndexes ? state.addedIndexes[0] : null;
      state.addedIndexes = [
        ...state.addedIndexes,
        {
          uid: Date.now() + Math.random(),
          id: "",
          name: "",
          current_monthFrom: mainIndex?.current_monthFrom
            ? mainIndex.current_monthFrom
            : null,
          current_dayFrom: mainIndex?.current_dayFrom
            ? mainIndex.current_dayFrom
            : null,
          current_monthTo: mainIndex?.current_monthTo
            ? mainIndex.current_monthTo
            : null,
          current_dayTo: mainIndex?.current_dayTo
            ? mainIndex.current_dayTo
            : null,
          current_yearFrom: mainIndex?.current_yearFrom
            ? mainIndex.current_yearFrom
            : null,
          current_yearTo: mainIndex?.current_yearTo
            ? mainIndex.current_yearTo
            : null,
          historical_yearFrom: mainIndex?.historical_yearFrom
            ? mainIndex.historical_yearFrom
            : null,
          historical_yearTo: mainIndex?.historical_yearTo
            ? mainIndex.historical_yearTo
            : null,
          spatialStats: mainIndex?.spatialStats ? mainIndex.spatialStats : "",
          temporalStats: mainIndex?.temporalStats
            ? mainIndex.temporalStats
            : "",
          periodOfTime: mainIndex?.periodOfTime
            ? mainIndex.periodOfTime
            : [
                {
                  label: "By day",
                  checked: true,
                  key: "same",
                },
                {
                  label: "10 Days",
                  checked: false,
                  key: "days",
                },
                {
                  label: "Month",
                  checked: false,
                  key: "month",
                },
                {
                  label: "Range",
                  checked: false,
                  key: "range",
                },
              ],
          temporalMethod: mainIndex?.temporalMethod
            ? mainIndex.temporalMethod
            : [
                {
                  label: "By pixel",
                  checked: false,
                  key: "pixel",
                },
                {
                  label: "By image",
                  checked: true,
                  key: "image",
                },
              ],
        },
      ];
    },
    setAddedIndexesTemporalMethod: (state, action) => {
      const { index, index2 } = action.payload;
      console.log(index, index2);
      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index2] = {
        ...updatedIndexes[index2],
        temporalMethod: updatedIndexes[index2].temporalMethod.map(
          (item, idx) => ({
            ...item,
            checked: idx === index,
          }),
        ),
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesPeriodOfTime: (state, action) => {
      const { index, index2 } = action.payload;
      console.log(index, index2);
      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index2] = {
        ...updatedIndexes[index2],
        periodOfTime: updatedIndexes[index2].periodOfTime.map((item, idx) => ({
          ...item,
          checked: idx === index,
        })),
      };

      state.addedIndexes = updatedIndexes;
    },
    deleteOneAddIndex: (state, action) => {
      const { index } = action.payload;
      // Create a new array with the item at the specified index removed
      const updatedAddedIndexes = state.addedIndexes.filter(
        (_, i) => i !== index,
      );

      // Update the state with the new array
      state.addedIndexes = updatedAddedIndexes;
    },
    setAddedIndexesId: (state, action) => {
      const { index, id } = action.payload;

      const updatedIndexes = [...state.addedIndexes];

      updatedIndexes[index] = {
        ...updatedIndexes[index],
        id: id,
      };

      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesName: (state, action) => {
      const { index, name } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the name property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        name: name,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesTempStat: (state, action) => {
      const { index, stat } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the name property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        temporalStats: stat,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesSpatialStat: (state, action) => {
      const { index, stat } = action.payload;
      console.log("index:::::", index, "stat:::::", stat);

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the name property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        spatialStats: stat,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setSelectedYearFromHistoricalAdded: (state, action) => {
      const { index, year } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];
      console.log(updatedIndexes);

      // Update the yearFrom property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        historical_yearFrom: year,
      };
      console.log(updatedIndexes);

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setSelectedYearToHistoricalAdded: (state, action) => {
      const { index, year } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the yearTo property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        historical_yearTo: year,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesmonthFrom: (state, action) => {
      const { index, monthFrom } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the monthFrom property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_monthFrom: monthFrom,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesmonthTo: (state, action) => {
      const { index, monthTo } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the monthTo property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_monthTo: monthTo,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesdayFrom: (state, action) => {
      const { index, dayFrom } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the dayFrom property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_dayFrom: dayFrom,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesdayTo: (state, action) => {
      const { index, dayTo } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the dayTo property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_dayTo: dayTo,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesYearTo: (state, action) => {
      const { index, yearTo } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the dayTo property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_yearTo: yearTo,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },
    setAddedIndexesYearFrom: (state, action) => {
      const { index, yearFrom } = action.payload;

      // Create a copy of the addedIndexes array
      const updatedIndexes = [...state.addedIndexes];

      // Update the dayTo property of the specified index
      updatedIndexes[index] = {
        ...updatedIndexes[index],
        current_yearFrom: yearFrom,
      };

      // Update the state with the updated addedIndexes array
      state.addedIndexes = updatedIndexes;
    },

    // mask
    setUploadMaskToggle: (state) => {
      state.uploadMaskToggle = !state.uploadMaskToggle;
    },
    setChooseOneRef: (state) => {
      state.chooseOneRef = !state.chooseOneRef;
    },
    setRefIndex: (state, action) => {
      state.RefIndex = action.payload;
    },
    setRangePairs: (state, action) => {
      state.rangePairs = action.payload;
    },
    setValues: (state, action) => {
      state.values = action.payload;
    },
    setRefToggle: (state) => {
      state.refToggle = !state.refToggle;
    },
    setRefFromDate: (state, action) => {
      state.refFromDate = action.payload;
    },
    setRefToDate: (state, action) => {
      state.refToDate = action.payload;
    },
    setRefPredFromDate: (state, action) => {
      state.refPredFromDate = action.payload;
    },
    setRefPredToDate: (state, action) => {
      state.refPredToDate = action.payload;
    },
  },
});

export const {
  // y data
  setDetranding,
  setMultiFeature,
  setFeaturesColumn,
  setLoadingfeatures,
  setSelectedFeaturesColumn,
  setModelName,

  // main index
  setAddedIndexesTemporalMethod,
  setAddedIndexesPeriodOfTime,
  setAddedIndexesSpatialStat,
  setAddedIndexesTempStat,
  setAddedIndexesId,
  setAddedIndexesYearFrom,
  setAddedIndexesYearTo,
  setAddedIndexesdayFrom,
  setAddedIndexesdayTo,
  setAddedIndexesmonthFrom,
  setAddedIndexesmonthTo,
  setSelectedYearFromHistoricalAdded,
  setSelectedYearToHistoricalAdded,
  setAddedIndexesInit,
  setAddedIndexesName,
  deleteOneAddIndex,

  // ref index
  setChooseOneRef,
  setRangePairs,
  setRefIndex,
  setRefToggle,
  setValues,
  setRefFromDate,
  setRefToDate,
  setUploadMaskToggle,
  setRefPredToDate,
  setRefPredFromDate,
} = predictionSlice.actions;

export default predictionSlice.reducer;
